const PUB = (process.env.PUBLIC_URL || "").replace(/\/+$/, "");

export const featureSlides = [
  {
    title: "One place for every booking",
    caption:
      "Create, edit, and bulk-assign jobs in seconds—no spreadsheets, no chaos.",
    image: `${PUB}/mercedes.png`,
  },
  {
    title: "Real-time control room",
    caption:
      "Track vehicles live, monitor driver KPIs, and get proactive alerts.",
    image: `${PUB}/mercedes.png`,
  },
  {
    title: "Invoices on autopilot",
    caption:
      "Generate and share branded invoices instantly for enterprises.",
    image: `${PUB}/mercedes.png`,
  },
];
